import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaBed } from "react-icons/fa";
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { checkPropertySaved, toggleSaveProperty } from '../services/Api'; 
// import { useAuth } from '../context/AuthContext'; 
import { getPropertyCount, getPropertyListNew } from "../services/Api";
import { useContext } from "react";
import { GlobalContext } from "../GlobalContext";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import { toast } from 'react-toastify';
import { useParams, useLocation } from "react-router-dom";




export default function StaticProperties() {
    const [properties, setProperties] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [category, setCategory] = useState("all");
    const [location, setLocation] = useState("");
    const [hasMore, setHasMore] = useState(true);
    const { globalVar } = useContext(GlobalContext);
    const [locations, setLocations] = useState([]);
    const [typeCount, setTypeCount] = useState([]);
    const { t } = useTranslation();
    const [savedProperties, setSavedProperties] = useState({});
    const [savingId, setSavingId] = useState(null);
    const [property, setProperty] = useState(null);
    const isLoggedIn = localStorage.getItem("accessToken");
    console.log('loggedin',isLoggedIn);
    const { id } = useParams(); // ✅ fix here
    const location_s = useLocation();
    const [isSaved, setIsSaved] = useState(location_s.state?.isSaved || false);
    

    // const locations = [
    //     "Abu Dhabi",
    //     "Dubai",
    //     "Sharjah",
    //     "Ajman",
    //     "Umm Al Quwain",
    //     "Ras Al Khaimah",
    //     "Fujairah",
    // ];
    // const locations = [
    //     { name: "Abu Dhabi", count: 16 },
    //     { name: "Dubai", count: 42 },
    //     { name: "Sharjah", count: 23 },
    //     { name: "Ajman", count: 9 },
    //     { name: "Umm Al Quwain", count: 7 },
    //     { name: "Ras Al Khaimah", count: 5 },
    //     { name: "Fujairah", count: 3 },
    // ];

    // useEffect(() => {
    //     getPropertyCountData();
    //     fetchProperties(page);
    // },[])
    const getPropertyCountData = async () => {
        try {
            const response = await getPropertyCount();
            if (response.success) {
                setLocations(response.data?.locations);
                setTypeCount(response.data?.count_data)
            }
            return response.data;
        } catch (error) {
            console.error("Error fetching property count:", error);
            return { success: false, data: null, message: null, error };
        }
    }

    const fetchProperties = async (newPage = 1, reset = false) => {
        try {
            setIsLoading(true);
            const categoryMap = {
                all: 0,
                off_plan: 1,
                ready_to_move: 2,
                coming_soon: 3
            };
            const categoryParam = categoryMap[category] || 0;

            const response = await getPropertyListNew(
                newPage,
                8,
                "latest",
                categoryParam,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                location
            );
            if (response?.results?.success) {
            const newData = response.results.data;
            setHasMore(!!response.next);

            const mergedData = reset ? newData : [...properties, ...newData];
            const uniqueMap = new Map();
            mergedData.forEach((item) => uniqueMap.set(item.id, item));
            const finalData = Array.from(uniqueMap.values());
            setProperties(finalData);

            if (isLoggedIn) {
            const savedStatusMap = { ...savedProperties };
            for (const prop of finalData) {
                if (savedStatusMap[prop.id] === undefined) {
                try {
                    const res = await checkPropertySaved(prop.id);
                    savedStatusMap[prop.id] = res.is_saved;
                } catch (err) {
                    console.warn(`Save status check failed for ID ${prop.id}`);
                }
                }
            }
            setSavedProperties(savedStatusMap);
            }
        }
        } catch (err) {
            console.error("Error fetching static properties:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggleSave = async (propertyId) => {
        if (!isLoggedIn) {
        toast.warning("Please log in to save properties");
        return;
        }

        setSavingId(propertyId);

        try {
        const response = await toggleSaveProperty(propertyId);
        setIsSaved(response.is_saved);
        setSavedProperties((prev) => ({
            ...prev,
            [propertyId]: response.is_saved
        }));
        toast.success(response.message || "Updated successfully!");
        } catch (error) {
        toast.error("Failed to update save status");
        console.error("Toggle save error:", error);
        } finally {
        setSavingId(null);
        }
    };
    useEffect(() => {
        console.log("Updated savedProperties:", savedProperties);
    }, [savedProperties]);

    // useEffect(() => {
    //     async function fetchProperty() {
    //     const res = await getPropertyDetail(id);
    //     setProperty(res);
    //     if (res.is_saved !== undefined) {
    //         setIsSaved(res.is_saved);
    //     }
    //     }

    //     fetchProperty();
    // }, [id]);


    useEffect(() => {
        setPage(1);
        getPropertyCountData();
        fetchProperties(1, true);
    }, [category, location]);

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchProperties(nextPage);
    };

    return (
        <section className="pt-[60px] pb-8 px-6 sm:px-8 lg:px-12 bg-gray-50">
            <div>
                <div className="w-full flex flex-col sm:flex-row flex-wrap justify-center items-center gap-4 mb-6 px-4">
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center sm:text-left">
                       {t("static.latest_properties")}
                    </h2>

                    <div className="flex flex-wrap justify-center gap-1">
                        {[
                           
  { label: t("static.off_plan"), value: "off_plan", count: typeCount?.off_plan_count || 0 },
  { label: t("static.ready"), value: "ready_to_move", count: typeCount?.ready || 0 },
  { label: t("static.coming_soon"), value: "coming_soon", count: typeCount?.coming_soon || 0 },


                        ].map((item) => (
                            <button
                                key={item.value}
                                onClick={() => setCategory(item.value)}
                                disabled={category === item.value}
                                className={`relative px-1 py-2.5 rounded-full text-[13px] sm:text-base font-semibold transition-all duration-300 overflow-hidden z-0 group flex items-center gap-1
                                ${category === item.value
                                        ? "text-white bg-teal-600 shadow-lg"
                                        : "text-teal-600 bg-white border border-teal-500"
                                    }`}
                            >
                                <span className="relative z-10 flex items-center gap-1">
                                    {item.label}
                                    <span
                                        className={`inline-block min-w-[22px] px-1 py-0.5 text-[10px] font-semibold rounded-full ${category === item.value ? "bg-white text-teal-600" : "bg-teal-100 text-teal-700"
                                            }`}
                                    >
                                        {item.count}
                                    </span>
                                </span>

                                {/* Hover Background Animation */}
                                <span
                                    className={`absolute inset-0 rounded-full transition-transform duration-300 transform scale-0 group-hover:scale-100 group-hover:bg-teal-500 z-0 ${category === item.value ? "scale-100 bg-teal-600" : ""
                                        }`}
                                ></span>
                            </button>
                        ))}
                    </div>

                </div>

                <div className="flex flex-wrap justify-center items-center gap-2 gap-y-6 sm:gap-4 mb-8 px-2 overflow-visible">
                    {locations.map((loc) => (
                        <button
                            key={loc.name}
                            onClick={() => setLocation(loc.name)}
                            disabled={location === loc.name}
                            className={`relative px-1  py-3 rounded-xl text-[13px] font-semibold transition-all duration-300 border flex items-center justify-center overflow-visible
        ${location === loc.name
                                    ? "bg-teal-600 text-white border-teal-600 shadow-md"
                                    : "bg-white text-gray-800 border-teal-500 group hover:text-white"
                                }`}
                        >
                            {/* Location Name */}
                            <span className="relative z-10">
  {t(`emirates.${loc.name.toLowerCase().replaceAll(" ", "_")}`, loc.name)}
</span>


                            {/* Count Badge (Bottom Center) */}
                            <span
                                className={`absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 z-20 px-2 py-0.5 text-[10px] font-semibold rounded-full ring-2 ring-white shadow-sm
          ${location === loc.name
                                        ? "bg-white text-teal-600"
                                        : "bg-teal-100 text-teal-700"
                                    }`}
                            >
                                {loc.count}
                            </span>

                            {/* Animated Hover Background */}
                            <span
                                className={`absolute inset-0 bg-teal-500 rounded-xl scale-0 group-hover:scale-100 transition-transform duration-300 ease-in-out ${location === loc.name ? "scale-100" : ""
                                    }`}
                            ></span>
                        </button>
                    ))}
                </div>



            </div>

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {isLoading && page === 1 ? (
                    <div className="col-span-full text-center py-10">
                        <svg
                            className="animate-spin h-8 w-8 text-teal-500 mx-auto"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                            ></circle>
                            <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
                            ></path>
                        </svg>
                        <p className="mt-2 text-gray-600">{t('loading_properties')}</p>
                    </div>
                ) : properties.length > 0 ? (
                    properties.map((property) => (
                        <Link
                            key={property.id}
                            to={{
                                    pathname: `/property-detail/${property.id}`,
                                    state: { isSaved: savedProperties[property.id] }  
                                }}
                                className="block bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
                                >
                            <div className="relative">
                                <img
                                    src={
                                        property.images?.[0]?.image
                                            ? property.images[0].image.startsWith("/media")
                                                ? `${globalVar}${property.images[0].image}`
                                                : property.images[0].image
                                            : "/placeholder.jpg"
                                    }
                                    alt={property.title}
                                    className="h-50 w-full object-cover"
                                />
                                
{property.category?.name && (
  <span className="absolute top-2 left-2 bg-black bg-opacity-60 text-white text-xs font-medium px-2 py-1 rounded">
    {t(
      `static.${property.category.name.toLowerCase().replace(/[-\s]/g, "_")}`,
      property.category.name
    )}
  </span>
)}



                                {/* Delivery Date */}
                                {property.delivery_date && (
                                    <span className="absolute top-2 right-2 bg-white text-black text-xs font-semibold px-2 py-1 rounded shadow-md">
                                        {new Date(property.delivery_date).toISOString().split('T')[0]}
                                    </span>
                                )}
                            </div>

                            <div className="p-4 space-y-1 relative">
                                {isLoggedIn && (
                                    <button
                                    onClick={() => handleToggleSave(property.id)}
                                    disabled={savingId === property.id}
                                    className="absolute top-13 right-5 text-teal-500 text-xl hover:scale-110 transition-transform"
                                    >
                                    {savedProperties[property.id] ? <FaHeart /> : <FaRegHeart />}
                                    </button>
                                )}
                                {/* <button
                                    onClick={() => handleToggleSave(property.id)}
                                    disabled={savingId === property.id}
                                    className={`absolute top-13 right-5 text-xl ${savedProperties[property.id]
                                        ? 'text-teal-500'
                                        : 'text-gray-400 hover:text-teal-300'
                                    } ${savingId === property.id ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    title={savedProperties[property.id] ? 'Unsave' : 'Save'}
                                    >
                                    {savedProperties[property.id] ? <FaHeart /> : <FaRegHeart />}
                                </button> */}
                                <div className="flex justify-between items-center text-sm text-gray-800 font-semibold">
                                    {property.price > 0 && (
<span className="text-black">
  {i18n.language === 'ar'
    ? `${Math.round(property.price).toLocaleString()} ${t("currency.dirham")}`
    : `${t("currency.dirham")} ${Math.round(property.price).toLocaleString()}`}
</span>


                                    )}
                                    
                                      <span className="text-gray-600 text-xs">
  {
    property.units?.length > 0
      ? [...new Set(property.units.map(unit => unit.unit_type))]
          .filter(Boolean)
          .map(type => t(`unit_types.${type?.toLowerCase().replace(/\s/g, '_')}`, type))
          .join(', ')
      : t(`unit_types.${property.property_type?.name?.toLowerCase().replace(/\s/g, '_')}`, property.property_type?.name)
  }
</span>

                                </div>

                                <h3 className="text-md font-semibold text-gray-800 line-clamp-1">
                                    {property.title}
                                </h3>

                                <p className="text-sm text-gray-500">
                                    {t(`emirates.${property.location?.emirate?.toLowerCase().replaceAll(" ", "_")}`, property.location?.emirate)}
                                    {property.community?.slug ? (
                                        ` / ${t(`communities.${property.community.slug}`, property.community.name)}`
                                    ) : ""}
                                    </p>

                                <div className="flex justify-between items-center text-sm text-gray-600 mt-2">
                                    {[
                                        ...new Set(property.units?.map((unit) => unit.rooms)),
                                    ].filter((room) => room).length > 0 && (
                                            <span className="flex items-center gap-1">
                                                <FaBed className="text-gray-500" />
                                                {[...new Set(property.units?.map((unit) => unit.rooms))]
                                                    .filter((room) => room)
                                                    .sort((a, b) => Number(a) - Number(b))
                                                    .join(", ")}
                                            </span>
                                        )}
<span>
  {i18n.language === 'ar'
    ? `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`
    : `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`}
</span>

                                </div>
                            </div>
                        </Link>
                    ))
                ) : (
                    <div className="col-span-full text-center py-10">
                       <p className="text-gray-600">{t('no_properties_found')}</p>
                    </div>
                )}
            </div>

            {hasMore && (
                <div className="mt-10 text-center">
                    <button
                        onClick={handleLoadMore}
                        disabled={isLoading}
                        className="px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-full transition"
                    >
                        {isLoading ? t('loading') : t('load_more')}
                    </button>
                </div>
            )}
        </section>
    );
}
